import React from "react";

const BS5_ListGroups = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_ListGroups Component</h2>
      <p>This is the BS5_ListGroups component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_ListGroups;
